import { observer } from "mobx-react-lite";
import React from "react";
import { useApi } from "../../core/apis";
import { useStores } from "../../core/stores";
import { LoadingCircular } from "../../ui/LoadingCircular";
import type { BusinessPlanModel } from "../plan/BusinessPlanModel";
import { BusinessCreatePlaniraUI } from "../plan/tabs/BusinessCreatePlanira";
import { PlanBusinessOverview } from "../plan/tabs/PlanBusinessOverview";

export const BusinessPlaniraLoader = observer(
  ({ businessPlan }: { businessPlan: BusinessPlanModel }) => {
    const { plansStore } = useStores();
    const { plansApi } = useApi();

    const planId = businessPlan?.userInPlan?.data.planUid;

    const plan = planId ? plansStore.byId.get(planId) : undefined;

    const [loading, setLoading] = React.useState(planId && !plan);

    React.useEffect(() => {
      if (planId) {
        return plansApi.watchItem(planId);
      }
    }, [planId, plansApi]);

    React.useEffect(() => {
      if (plan) {
        setLoading(false);
      }
    }, [plan]);

    if (loading) {
      return <LoadingCircular />;
    }

    if (!plan) {
      return <BusinessCreatePlaniraUI businessPlanUid={businessPlan.uid} />;
    }

    return <PlanBusinessOverview plan={plan} />;
  },
);
